import React, { useEffect, useRef, useState } from "react";
import "./GenericChatbotContainer.css";
import iq_api_v2 from "../../../../services/iqApiV2";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOpportunitiesRequest,
} from "../../../../store/features/actions/opportunities/opportunitesActions";
import {
  fetchWinOpportunitiesRequest,
} from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import SelectDropDownComp from "./selectDropDownComp";
import { useWebSocket } from "../../uiUtils/useWebSocket";
import PersonCard from "./personCard/PersonCard";
import { FetchSpotContactsRequest } from "../../../../store/features/actions/targetedReachout/spotContactsActions";
import { WSS_URL } from "../../../../config/apiConfig";

const AddContactForm = ({ dropDownData, onApplyDropdown }) => {
  const [selectedOpportunities, setSelectedOpportunities] = useState([]);

  return (
    <div className="chatbot-add-container">
      <div className="chatbot-form-header">
        <span className="chatbot-form-text-titl">Please choose opportunity</span>
        <span className="chatbot-form-text-titl clickable" onClick={() => setSelectedOpportunities([])}>
          Clear
        </span>
      </div>
      <SelectDropDownComp
        allOptions={dropDownData}
        selectedValues={selectedOpportunities}
        setSelectedValues={setSelectedOpportunities}
        onApply={onApplyDropdown}
        multiSelect={false}
        valueKey="_id"
        labelKey="opportunity_name"
        disableFooter={false}
      />
    </div>
  );
};

const ChatContainerForContactAddSc = ({ onBack, type }) => {
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const textareaRef = useRef(null);
  const [flowType, setFlowType] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [oppData, setOppData] = useState({ linkedin_url: "" });
  const [taskId, setTaskId] = useState(null);
  const [isSelected, setIsSelected] = useState([]);
  const isSelectedRef = useRef([]);

  useEffect(() => {
    isSelectedRef.current = isSelected;
  }, [isSelected]);

  const { opportunitesData = [] } = useSelector((s) => s.opportunitiesReducer);
  const { winOpportunitesData = [] } = useSelector((s) => s.winOpportunitiesReducer);

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      if (!opportunitesData.length)
        dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));
      if (!winOpportunitesData.length)
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
    }
  }, [clientName, accountName, user?.id]);

  useEffect(() => {
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, [message]);

  useEffect(() => {
    containerRef.current.scrollTop = containerRef.current.scrollHeight;
  }, [chatMessages]);

  const handleToggleSelect = (person) => {
    setIsSelected((prev) =>
      prev.some((p) => p.id === person.id)
        ? prev.filter((p) => p.id !== person.id)
        : [...prev, person]
    );
  };

useWebSocket(taskId ? `${WSS_URL}/${taskId}` : null, (data) => {
  const people = data?.result?.people || [];

  if (data?.status === "pending") {
    // If last message is not loading, add a new one. Else, update.
    setChatMessages((prev) => {
      const last = prev[prev.length - 1];
      if (!last?.isLoading) {
        return [...prev, {
          sender: "SalesIQ",
          message: "⏳ Processing your request...",
          isLoading: true
        }];
      } else {
        return prev.map((msg, i) =>
          i === prev.length - 1 ? { ...msg, message: "⏳ Processing your request..." } : msg
        );
      }
    });
  }

  if (data?.status === "failed") {
    updateLastMessage("❗ Something went wrong while processing your request.");
  }

if (data?.status === "completed") {
  updateLastMessage(
    people?.length > 0 ? (
      <div>
        {people.map((person) => (
          <PersonCard
            key={person.id}
            person={person}
            isSelected={isSelectedRef.current.some((p) => p.id === person.id)}
            onSelectChange={handleToggleSelect}
              dropDownData={[...opportunitesData, ...winOpportunitesData]}
          />
        ))}
        <div>Found {people?.length || 0 } contacts</div>
      </div>
    ) : (
      <>People Not Found. Please Retry</>
    )
  );
}

});


  const getTime = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const pushMessage = (sender, content, isLoading = false) => {
    setChatMessages((prev) => [
      ...prev,
      { sender, message: content, isLoading, timestamp: !isLoading ? getTime() : undefined },
    ]);
  };

  const updateLastMessage = (newContent) => {
    setChatMessages((prev) => {
      const updated = [...prev];
      const last = updated.length - 1;
      updated[last] = { ...updated[last], message: newContent, isLoading: false, timestamp: getTime() };
      return updated;
    });
  };

  const initializeChat = () => {
    setFlowType(null);
    setChatMessages([
      {
        sender: "SalesIQ",
        message: (
          <>
            <div>{`Hi ${user?.firstname}! 👋 Would you like to find a Contact or add a new one?`}</div>
            <div className="find-opp-catagory-container">
              <button onClick={() => handleFlowSelection("find")} className="find-opp-catagory-container-btn">
                Find Contact
              </button>
              <button onClick={() => handleFlowSelection("add")} className="find-opp-catagory-container-btn">
                Add Contact
              </button>
            </div>
          </>
        ),
        timestamp: getTime(),
      },
    ]);
  };

  const handleFlowSelection = (type) => {
    setFlowType(type);
    pushMessage("SalesIQ", type === "find" ? "Please provide contact prompt." : "Please enter the LinkedIn URL.");
  };

  const handleOpportunityApply = async (selected, linkedin_url) => {
    pushMessage("SalesIQ", null, true);
    try {
      const payload = {
        user_id: user?.id,
        linkedin_url,
        opportunity_ids: [selected._id],
      };
      const res = await iq_api_v2.post("contact/add_contact_against_opportunity", payload);
      updateLastMessage("Adding contact. Please wait...");
      if (res?.data) {
      dispatch(
        FetchSpotContactsRequest({
          clientName,
          accountName,
          userId: user?.id,
          type: "spot",
        })
      );
      }
      pushMessage("SalesIQ", res?.data?.next_prompt || "Thanks. Contact has been added successfully.");
    } catch (err) {
      updateLastMessage(`❗ ${err?.response?.data?.message || "Something went wrong"}`);
    } finally {
      setMessage("");
      setOppData({ linkedin_url: "" });
      setChatMessages(prev => [...prev,
        {
          sender: "SalesIQ",
          message: (
            <>
              <div>{`Hi ${user?.firstname}! 👋 Would you like to find another Contact or add a new one?`}</div>
              <div className="find-opp-catagory-container">
                <button onClick={() => handleFlowSelection("find")} className="find-opp-catagory-container-btn">
                  Find Contact
                </button>
                <button onClick={() => handleFlowSelection("add")} className="find-opp-catagory-container-btn">
                  Add Contact
                </button>
              </div>
            </>
          ),
          timestamp: getTime(),
        },
      ]);
    }
  };


  const handleUserInput = async (input) => {
    if (!input.trim()) return;
    pushMessage(user?.firstname || "User", input);
    setMessage("");

    if (flowType === "add" && !oppData.linkedin_url) {
      const linkedin = input.trim();
      setOppData({ linkedin_url: linkedin });
      pushMessage("SalesIQ", (
        <AddContactForm
          dropDownData={[...opportunitesData, ...winOpportunitesData]}
          onApplyDropdown={(selected) => handleOpportunityApply(selected, linkedin)}
        />
      ));
    }

    if (flowType === "find") {
      pushMessage("SalesIQ", null, true);
      try {
        const payload = { client: clientName, account: accountName, prompt: input, user_id: user?.id };
        const res = await iq_api_v2.post("contact/find_contacts", {}, { params: payload });
        updateLastMessage("Finding contact. Please wait...");
        if (res?.data?.task_id) setTaskId(res.data.task_id);
      } catch (err) {
        updateLastMessage(`❗ ${err?.response?.data?.message || "Something went wrong"}`);
      }
    }
  };

  const renderMessages = () =>
    chatMessages.map((msg, i) => {
      const isUser = msg.sender === user?.firstname;
      const showSender = i === 0 || chatMessages[i - 1].sender !== msg.sender;
      return (
        <div key={i} className={`message-wrapper ${isUser ? "align-right" : "align-left"}`}>
          {showSender && <p className="sender-name">{msg.sender}</p>}
          <div className={`message-bubble-${isUser ? "User" : msg.sender} ${msg.isLoading ? "is-loading" : ""}`}>
            <div className="message-content">{msg.message}</div>
            {!msg.isLoading && msg.timestamp && (
              <div className={`message-timestamp-${isUser ? "User" : msg.sender}`}>{msg.timestamp}</div>
            )}
          </div>
        </div>
      );
    });

  const handleBackAndReset = () => {
    setMessage("");
    setOppData({ linkedin_url: "" });
    setChatMessages([]);
    initializeChat();
    onBack();
  };

  useEffect(() => {
    initializeChat();
  }, []);

  return (
    <div className="chatbox-container">
      <div className="chatbox-header" onClick={handleBackAndReset}>
        <img className="back-btn-img" src="/img/back_top.png" alt="Back" />
        <span className="back_chat_top">Back</span>
      </div>
      <div className="chatbox-messages-container" ref={containerRef}>
        {renderMessages()}
      </div>
      <div className="chatbox-input-container">
        <textarea
          ref={textareaRef}
          className="chatbox-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type here..."
        />
        <button className="send-button" onClick={() => handleUserInput(message)}>
          <img className="send-button-img" src="/img/arrow-up.png" alt="Send" />
        </button>
      </div>
    </div>
  );
};

export default ChatContainerForContactAddSc;